/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { Footer } from "gui/footer/footer";
import { PageHead } from "gui/head/head";
import { Header } from "shared/Header/Header";
import { PageMain } from "gui/page/page";
import { Spacer } from "gui/spacer/spacer";
import NotFoundPage from "pages/404";
import TeamEntries from "./TeamEntries/TeamEntries";
import TeamProfile from "./TeamProfile/TeamProfile";

import fetchStaticTeamProfileData, {
  StaticTeamProfileData,
} from "./fetchStaticTeamProfileData";
import QueriesListOnProfile from "gui/profile-shared/queries/QueriesListOnProfile";
import DashboardsListOnProfile from "gui/profile-shared/dashboards/DashboardsListOnProfile";

export interface Props {
  team: StaticTeamProfileData;
  preview: boolean;
  timestamp: string;
}

export default function TeamProfilePage(props: Props) {
  if (!props.team) {
    return <NotFoundPage />;
  }

  const { team } = props;
  const dc = team.dashboards.total_count;
  const qc = team.queries.total_count;
  const dashboardsTitle = dc === 1 ? `1 dashboard` : `${dc} dashboards`;
  const queriesTitle = qc === 1 ? `1 query` : `${qc} queries`;

  return (
    <>
      <PageHead title={team.name} preview={props.preview} />
      <Header />
      <PageMain size="md">
        <TeamProfile
          key={team.id}
          team={team}
          dashboardsCount={team.dashboards.total_count}
          queriesCount={team.queries.total_count}
          people={team.members}
        />
        <Spacer />
        <TeamEntries
          team={team}
          list={
            dc > 0 && (
              <DashboardsListOnProfile
                owner={{ handle: team.handle }}
                dashboards={team.dashboards.list}
              />
            )
          }
          title={dashboardsTitle}
          slug="dashboards"
        />
        <Spacer />
        <TeamEntries
          team={props.team}
          list={
            qc > 0 && (
              <QueriesListOnProfile
                owner={{ handle: team.handle }}
                queries={team.queries.list}
              />
            )
          }
          title={queriesTitle}
          slug="queries"
        />
      </PageMain>
      <Footer timestamp={props.timestamp} />
    </>
  );
}

export async function fetchProps(
  handle: string
): Promise<Pick<Props, "team"> | undefined> {
  const team = await fetchStaticTeamProfileData(handle);

  if (!team) {
    return undefined;
  }

  return {
    team,
  };
}
